import { WhiteLabelData } from 'reactApp/modules/WhiteLabelModule/WhiteLabelModule.types';

const greenatom: WhiteLabelData = {
    billing_settings: {
        available_payment_methods: [],
        enabled: true,
    },
    partner_services: [],
    support_contacts: {
        email: '',
        question_form_url: '',
        phone: '',
    },
    available_services: [
        'bigdata',
        'containers',
        'databases',
        'gpu',
        'hotbox',
        'infra',
        'vision',
        'marketplace',
    ],
    tag: 'greenatom',
    ui_settings: {
        page_title: 'Greenatom',
        theme: 'Greenatom',
        hide_external_links: true,
        hide_access_control: true,
        hide_project_creation: true,
    },
};

export const WhitelabelConfigs = {
    greenatom,
};
